// removed by extract-text-webpack-plugin
module.exports = {"option":"option___2ftTm","del":"del___3Oxro","entry":"entry___1HAii","add":"add___TbUs2","label":"label___4gVw-"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/EditVariable/SampleFromAnonymousEditor/styles.scss
// module id = 435
// module chunks = 0